import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import Grid from '../Grid';
import Cell from '../Cell';
import Button from '../Button';
import Container from '../Container';
import HeroText from '../HeroText';
import Header from '../Header';
import Footer from '../Footer';

import styles from './contact.css';

const { div, p } = hh(h);

const Contact = (props) => {
    return div({className: styles.contactWrapper}, [
        h(Header),
        h(Container, {theme: 'five', size: 'big'}, [
            h(HeroText, {subText: ''}, 'Contact')]),
          h(Container, {size: 'big'}, [
            h(Grid, [
                h(Cell, {classes: [styles.contactContainer]}, [
                    p({className: styles.contactHeader}, 'Are you a university who wants to talk to us?'),
                    h(Button, {arrow: true, mailto: true, arrowPosition: 'front', href: 'mailto:elliot@codeatuni.com', theme: 'white'}, 'Email us')]),
                h(Cell, {classes: [styles.contactContainer]}, [
                    p({className: styles.contactHeader}, 'All other enquiries'),
                    h(Button, {arrow: true, arrowPosition: 'front', mailto: true, href: 'mailto:hello@codeatuni.com', theme: 'white'}, 'Email us')])])
          ]),
        h(Container, [
            h(Footer)])
    ]);
};

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/Contact/index.js
 **/